import { AttachmentFile } from '@billy/design-system'

import { CreateDaybookTransactionPayload } from '@features/daybook/query-api'
import { Organization } from '@modules-deprecated/app/organization/types/organization'
import { BankLine } from '@modules-deprecated/bankReconciliation/types'

import { Side } from '../../../../../../../enums/side'
import { CreateManualPaymentForm } from './formData'

interface GetTransactionPayloadParams {
  transaction: BankLine
  organization: Organization
  formData: CreateManualPaymentForm
  attachmentsFiles: AttachmentFile[]
}

export const getTransactionPayload = ({
  transaction,
  organization,
  formData,
  attachmentsFiles,
}: GetTransactionPayloadParams): CreateDaybookTransactionPayload | null => {
  const organizationId = organization?.id
  const daybookId = organization?.defaultDaybookId
  const isBankDebit = transaction?.side === Side.Debit

  if (!organizationId || !transaction || !daybookId) {
    return null
  }

  return {
    daybookId,
    entryDate: transaction.entryDate,
    organizationId,
    state: 'approved',
    type: 'entry',
    voucherNo: formData.receiptNumber,
    attachments: attachmentsFiles.map((file) => ({ fileId: file.id, organizationId })),
    lines: [
      {
        accountId: formData.accountId,
        amount: transaction.amount,
        contraAccountId: transaction.accountId,
        side: isBankDebit ? Side.Credit : Side.Debit,
        taxRateId: formData.vatRateId,
        text: formData.description,
      },
    ],
  }
}
